import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PopupModule } from '@progress/kendo-angular-popup';
import { CommonModule } from 'app/common.module';
import { ClickOutsideModule } from 'ng-click-outside';

import { PopoverContentComponent } from './popover-content/popover-content.component';
import { PopoverComponent } from './popover.component';

@NgModule({
  imports: [ClickOutsideModule, CommonModule, PopupModule],
  exports: [PopoverComponent, PopoverContentComponent],
  declarations: [PopoverComponent, PopoverContentComponent],
  providers: [],
})
export class PopoverModule {}
